import Cookies from "js-cookie";

document.addEventListener("DOMContentLoaded", code);

function code(event) {
    //allow access to our URL params
    const urlParams = new URLSearchParams(window.location.search);

    //try to get "gated_content" or any "gated_content_[id]" param
    let gated_content_param = urlParams.get("gated_content");
    let gated_content_key = 'gated_content';

    //if we don't have a global gated content param, try to find one in the URL
    if (!gated_content_param) {

        //loop through all URL params
        for (const [key, value] of urlParams.entries()) {

            //if the key starts with "gated_content_" and has a value, we assume it's the gated content param
            if (key.startsWith("gated_content_") && value) {

                //save the first gated content param we find
                gated_content_key = key;
                gated_content_param = value;
                break;
            }
        }
    }

    //if we have the gated content param
    if (gated_content_param) {

        //attempt to fetch the gated download button
        let download_buttons = document.getElementsByClassName(
            "gated-content-download"
        );

        //if there's at least one download button on the page, we assume the validation is successful
        if (download_buttons && download_buttons.length > 0) {

            //find the container of the first download button
            let container = download_buttons[0].closest('.container');

            //scroll to the first block with the gated content download button
            container.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });

            //create a new version of the URL without our param in it
            let updated_url = window.location.href;

            //remove the gated content param from the URL
            updated_url = updated_url.replace(
                "?" + gated_content_key + "=" + gated_content_param,
                ""
            );

            //if the gated content param was in the URL as a query string, remove it
            updated_url = updated_url.replace(
                "&" + gated_content_key + "=" + gated_content_param,
                ""
            );

            //replace this page in history to prevent simple copy/pasting of an authed URL
            window.history.replaceState({}, document.title, updated_url);

            //save the gated content param to a URL for 7 days
            Cookies.set(gated_content_key, gated_content_param, { expires: 7 });
        }
    }
}